<template>
  <div class="monitor__container d-flex flex-column align-items-center w-100" data-test-id="MonitorComponent">
    <div class="monitor-form d-flex flex-row mt-4">
      <b-select
        v-model="monitorId"
        :options="monitorOptions"
        :required="true"
        :state="isMonitorValid"
        class="col-6 text-center p-2 pr-4"
      />

      <div class="ml-2 monitor-form__patient">
        <b-input
          v-model="patientId"
          :formatter="formatPatientId"
          :required="true"
          :state="isPatientValid"
          type="tel"
          min="1"
          max="9999"
          maxlength="4"
          placeholder="0000"
          autocomplete="off"
          class="text-center p-2"
        />
        <span class="d-block font-weight-bold mt-2">Enter PT ID</span>
      </div>
    </div>

    <div class="monitor-footer d-flex w-75 justify-content-between mt-5">
      <a class="btn border-light bg-light font-weight-bold text-primary" @click.prevent="onCancel">Cancel</a>
      <a
        :disabled="!isValid"
        tabindex="0"
        class="btn border-light bg-light font-weight-bold text-primary ml-2"
        @click.prevent="onSave"
        @keydown.enter="onSave"
      >
        Save
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { CaseEvent } from "@/Case/CaseEvent";

const EVENT_TYPE = "monitor";

export default Vue.extend({
  name: "Monitor",

  props: {
    monitors: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      monitorId: null,
      patientId: null,
    };
  },

  computed: {
    isMonitorValid() {
      return !!this.monitorId;
    },
    isPatientValid() {
      return !!this.patientId;
    },
    isValid() {
      return this.isMonitorValid && this.isPatientValid;
    },
    monitorOptions() {
      const parsedToOption = this.monitors.map((monitor) => ({
        value: monitor._id,
        text: monitor.name,
      }));

      return [{ value: null, text: "Select Monitor", disabled: true }, ...parsedToOption];
    },
  },

  mounted() {
    if (this.formData) {
      this.monitorId = this.formData.monitorId;
      this.patientId = this.formData.patientId;
    } else if (this.monitors.length === 1) {
      this.monitorId = this.monitors[0]._id;
    }
  },

  methods: {
    formatPatientId: (value) => value.replace(/\D/g, ""),

    onSave() {
      const { type: monitorType } = this.monitors.find(({ _id }) => _id === this.monitorId);

      this.$emit(CaseEvent.MODIFY, {
        eventType: EVENT_TYPE,
        data: {
          patientId: this.patientId,
          monitorId: this.monitorId,
          type: monitorType,
        },
      });
    },
    onCancel() {
      this.$emit("hide-modal");
    },
  },
});
</script>

<style lang="scss" scoped>
$sm-input-width: 160px;
$md-input-width: 200px;

* {
  user-select: none;
}

input,
select {
  width: $md-input-width;
}

input {
  letter-spacing: 0.5rem;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
}

select {
  appearance: none;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form-control {
  &.is-valid,
  &.is-invalid {
    // Removes validation feedback image for inputs.
    background-image: none;
  }
}
.custom-select {
  text-align: center;
  text-align-last: center;
  -moz-text-align-last: center;

  &.is-valid,
  &.is-invalid {
    // Removes validation feedback image for selects. Leaves only the default Bootstrap SVG for "select arrows".
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
      right 0.75rem center/8px 10px no-repeat;
  }
}

.monitor-footer a {
  font-size: 1.2rem;
  flex-basis: 100%;

  &[disabled="disabled"] {
    opacity: 0.5;
    pointer-events: none;
  }
}

@media (max-width: 575px) {
  h3 {
    font-size: 1.3rem;
  }
  input,
  select {
    width: $sm-input-width;
  }
}
</style>
